var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.414 2H6C4.897 2 4 2.898 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V6.586L15.414 2ZM7 12H15V14H7V12ZM17 18H7V16H17V18ZM14 8V3L19 8H14Z",
    fill: "#F4511E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 8,
    fill: "#F4511E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40882 18V14.3636H8.84348C9.11929 14.3636 9.35426 14.4163 9.54838 14.5217C9.74251 14.6258 9.89048 14.7708 9.99228 14.9567C10.0953 15.1413 10.1468 15.3544 10.1468 15.5959C10.1468 15.8374 10.0947 16.0504 9.9905 16.2351C9.88633 16.4197 9.73541 16.5636 9.53773 16.6665C9.34123 16.7695 9.10331 16.821 8.82395 16.821H7.90953V16.2049H8.69966C8.84763 16.2049 8.96955 16.1795 9.06543 16.1286C9.16249 16.0765 9.2347 16.0049 9.28205 15.9137C9.33058 15.8214 9.35485 15.7154 9.35485 15.5959C9.35485 15.4751 9.33058 15.3698 9.28205 15.2798C9.2347 15.1887 9.16249 15.1183 9.06543 15.0685C8.96837 15.0176 8.84526 14.9922 8.69611 14.9922H8.17765V18H7.40882ZM10.6461 18V14.3636H12.0808C12.3566 14.3636 12.5916 14.4163 12.7857 14.5217C12.9798 14.6258 13.1278 14.7708 13.2296 14.9567C13.3326 15.1413 13.3841 15.3544 13.3841 15.5959C13.3841 15.8374 13.332 16.0504 13.2278 16.2351C13.1236 16.4197 12.9727 16.5636 12.775 16.6665C12.5785 16.7695 12.3406 16.821 12.0613 16.821H11.1468V16.2049H11.937C12.0849 16.2049 12.2069 16.1795 12.3027 16.1286C12.3998 16.0765 12.472 16.0049 12.5194 15.9137C12.5679 15.8214 12.5922 15.7154 12.5922 15.5959C12.5922 15.4751 12.5679 15.3698 12.5194 15.2798C12.472 15.1887 12.3998 15.1183 12.3027 15.0685C12.2057 15.0176 12.0826 14.9922 11.9334 14.9922H11.415V18H10.6461ZM13.7449 14.9975V14.3636H16.7314V14.9975H15.6182V18H14.8582V14.9975H13.7449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPpt);
export default __webpack_public_path__ + "static/media/IconPPT.381c2c74.svg";
export { ForwardRef as ReactComponent };